import { bl_mlm_program_participant_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";


export class MlmProgramParticipantContainerModel extends BaseContainerModel {

    bl_mlm_program_participant_hdr : bl_mlm_program_participant_hdr_RowClass = new bl_mlm_program_participant_hdr_RowClass();
}